import { api } from '@api/api2';

const getData = () => api.v4('get', 'personal-account/resource-company/list');

export const apiRequests = { getData };
